export const isAndroidWebView = () => {
    return /Android/.test(navigator.userAgent);
};